import { useEffect } from 'react';
import { Post } from './api';

interface Props {
  post: Post;
  onCancel: () => void;
  onConfirm: (id: number) => void;
}

export default function DeleteModal({ post, onCancel, onConfirm }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#28341457] p-6 backdrop-blur-sm"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-modal-title"
        className="w-full max-w-[440px] rounded-2xl bg-white p-8 text-left shadow-2xl"
      >
        <h2 id="delete-modal-title" className="font-trirong_reg text-2xl text-gray-800">Delete this blog?</h2>
        <p className="mt-2.5 font-trirong_light text-gray-600">
          You are about to delete{' '}
          <span className="text-lime-700">"{post.title || 'Untitled'}"</span>.
        </p>
        <p className="mt-2 font-trirong_light text-gray-600">
          This cannot be undone, and if it is published it will be removed from your website.
        </p>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            autoFocus
            onClick={onCancel}
            className="rounded-full border border-field px-5 py-2 font-trirong_reg text-lime-700
                       transition-colors hover:border-lime-700 hover:bg-[#fbfdf4]
                       focus:outline-none focus:ring-2 focus:ring-lime-600/40"
          >
            Keep it
          </button>
          <button
            type="button"
            onClick={() => onConfirm(post.id)}
            className="rounded-full bg-danger px-5 py-2 font-trirong_reg text-[#fdecea]
                       transition-colors hover:bg-danger-deep focus:outline-none
                       focus:ring-2 focus:ring-danger/40"
          >
            Delete blog
          </button>
        </div>
      </div>
    </div>
  );
}
